import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideFeedbackBlockData from '../../../Models/Content/GenericGuideFeedbackBlockData';
import GenericGuideFeedback from './GenericGuideFeedbackBlock';

export default class GenericGuideFeedbackBlock extends EpiComponent<GenericGuideFeedbackBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-feedback-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideFeedback iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

